import React from 'react';
import cx from 'classnames';
// components
import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';
import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';
// styles
import imageSectionStyles from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import styles from './FreeShippingImageSection.module.less';

const FreeShippingImageSection: React.FC = () => {
  const renderText = () => (
    <div className={imageSectionStyles.dek}>
      When you receive gifts, you can choose to ship them right away,{' '}
      <a
        href="/faq/115002837272-how-can-i-exchange-my-gifts-before-they-ship-will-my-guests-find-out-"
        rel="noreferrer noopener"
      >
        exchange any before they ship
      </a>{' '}
      (without guests finding out!), or{' '}
      <a
        href="/faq/360004776432-does-zola-offer-free-shipping-and-returns-"
        rel="noreferrer noopener"
      >
        ship them later
      </a>{' '}
      when you have room. We’re the only registry with this thoughtful feature.
    </div>
  );
  return (
    <ImageSection
      headerTag="h2"
      backgroundColor={bgColorOption.lightGray}
      title={<div className={imageSectionStyles.title}>Free Shipping That You Control</div>}
      textPosition="left"
      imageContents={
        <>
          <div className={cx(styles.secondaryImage)}>
            <span role="img" aria-label="custom photo background save the date card" />
          </div>
          {renderAsBackgroundImage({
            selector: `.${styles.secondaryImage}`,
            backgroundImageName: 'registry_benefits_shipping',
            directory: 'WeddingRegistryBenefitsLP/freeShipping',
            filetype: ['png', 'png', 'png'],
          })}
        </>
      }
      secondaryContents={renderText()}
    />
  );
};

export default FreeShippingImageSection;
